import { render } from "./UserManageView.vue?vue&type=template&id=95129880"
import script from "./UserManageView.vue?vue&type=script&lang=js"
export * from "./UserManageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../2026-11-02/referenced-chatgpt-conversation-this-is-an-4/outputs/docker-delivery-user-management/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__